import { createSelector } from '@ngrx/store';
import { availablePickupsState } from '../root';

export const getAvailablePickupTimesForLocation = (locationNo: number) =>
    createSelector(availablePickupsState, (availablePickups) => availablePickups?.find((obj) => obj.locationNo === locationNo) || null);
